<template>
  <div>
    <div v-show="!callStarted">
      <div class="img" style="margin-top:144px"></div>
      <p class="title">您可点击右侧号码拨号</p>
      <p class="describe"><span :style="{color:isConnected?'#66bb6a':'var(--warning-color)'}">{{isConnected?'话机已链接':'话机未链接'}}</span></p>
    </div>
    <call-sub v-show="callStarted"></call-sub>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { eventHub } from "../../common/utils.js";
import callSub from "./callSub.vue";

export default {
  props:['isCall'],
  components: {
    callSub
  },
  data() {
    return {
      isConnected: false
    };
  },
  computed: {
    ...mapState({
      callStarted: state => state.callInfo.callStarted,
      isAddedClue: state => state.callInfo.reportObj.isAddedClue,
      thread: state => state.callInfo.thread
    })
  },
  watch: {
    thread(val) {
      if (val&&this.isCall) {
        this.getConnectStatus();
      }
    }
  },
  methods: {
    getConnectStatus() {
      if(this.isAddedClue==2){
        return false
      }
      try {
        let now = new Date().getTime() + Math.random();
        window["getConnected"] = res => {
          window.clearTimeout(this.timer);
          if (res.data.connect_status == 1) {
            this.isConnected = true;
          } else {
            this.isConnected = false;
          }
          window["getConnected"] = null;
        };
        let url =
          "https://localhost:10081/JD_get_connect_status?_=" +
          now +
          "&callback=getConnected";
        this.fetchJsonp(url);
        this.removeEle("connect");
      } catch (error) {
        return;
      }
    },
    fetchJsonp(url) {
      let body = document.getElementsByTagName("body")[0];
      let script = document.createElement("script");
      script.setAttribute("src", url);
      script.setAttribute("id", "connect");
      body.appendChild(script);
    },
    removeEle(id) {
      let body = document.getElementsByTagName("body")[0];
      let ele = document.getElementById(id);
      body.removeChild(ele);
    }
  }
};
</script>
<style lang="scss" scoped>
.img {
  width: 112px;
  height: 112px;
  text-align: center;
  line-height: 112px;
  border-radius: 3px;
  margin: 144px auto 30px;
  // background-color: #e2f3f3;
  background-image: url("../../assets/big.png");
  background-position: center center;
  background-repeat: no-repeat;
}
.title {
  font-size: 20px;
  color: #333;
  text-align: center;
}
.describe {
  font-size: 14px;
  color: #66bb6a;
  margin-top: 10px;
  text-align: center;
}
.btns {
  text-align: center;
  margin-top: 20px;
  button {
    font-size: 14px;
    color: #fff;
    outline: none;
    border: none;
    cursor: pointer;
  }
  .left {
    width: 90px;
    height: 34px;
    border-radius: 2px;
    background-color: var(--warning-color);
    margin-right: 10px;
  }
  .right {
    width: 90px;
    height: 34px;
    border-radius: 2px;
    background-color: var(--theme-color);
  }
}
.info {
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  padding: 15px 20px;
  margin-top: 20px;
  .name {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 10px;
  }
}
.from {
  .count {
    text-align: right;
    padding: 0px 20px;
    color: #555;
    font-size: 12px;
    border-bottom: 1px solid #ececec;
    padding-bottom: 5px;
    span {
      color: #999;
    }
  }
  .btn {
    padding: 0 20px;
    margin-top: 10px;
  }
  button {
    width: 100%;
    border-radius: 2px;
    background-color: #dddddd;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    outline: none;
    border: none;
    &.save {
      background: var(--theme-color);
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.from {
  .content {
    .el-textarea__inner {
      border: none;
      height: 160px;
      padding: 10px 20px;
      &:focus {
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/call.vue